//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/VisualReporting.js";
import "../no/Object.js";
import "../no/NXColor.js";
import "../no/NXObject.js";
import "../no/Session.js";
let d=[[[0,"Current",1,"VisualReporting.VisualReport",0]],[[["visualReport"],"CreateVisualReportBuilder",{R_:{visualReportBuilder:"VisualReporting.VisualReportBuilder"}},1,0],[["filename"],"Open",{R_:{visualReport:"VisualReporting.VisualReport"}},1,0],[["visualReport"],"Unload",{},1,0],[["folders","names","nReports"],"OpenReports",{R_:{visualReports:"VisualReporting.VisualReport[]"}},2,0],[[],"ActivateCurrentVisualReport",{},0,0],[[],"DeactivateCurrentVisualReport",{},0,0],[["visualReports","mergedReportName","mergedReportDescription"],"MergeReports",{R_:{mergedReport:"VisualReporting.VisualReport"}},3,0],[[],"CreateSpecifyDateBuilder",{R_:{specifyDateBuilder:"VisualReporting.SpecifyDateBuilder"}},0,0],[["propertyKey"],"UnregisterProperty",{},1,0],[["reportNamesCount"],"GetAllVisualReportNames",{R_:{reportNames:""}},0,0],[["reportNamesCount"],"GetSustainabilityVisualReportNames",{R_:{reportNames:""}},0,0],[["visualReportName","reportResultsCount"],"GenerateVisualReport",{R_:{reportResults:""}},1,0]],[["VisualReports","VisualReporting.VisualReportCollection",0],["VisualReportExplorer","VisualReporting.VisualReportExplorer",0]]];
SPLM.VisualReporting.VisualReportManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.VisualReporting.VisualReportManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.VisualReporting.VisualReportManager.ObjectResults = class{
    constructor(name,colorCode,entity){
        this.name=name;this.colorCode=colorCode;this.entity=entity;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Colorcode(){if(this.colorCode === undefined) this.colorCode = new SPLM.NXColor.Rgb(); return this.colorCode}
    set Colorcode(val){this.colorCode = val}
    get Entity(){return this.entity}
    set Entity(val){this.entity = val}
};

export default SPLM;